<template>
  <div class="login-form" v-show="showQr">
    <div class="form-header">
      <p>扫码登录</p>
      <div class="form-weixin" v-show="showQrCode">
        <div class="go-weixin">用户名登录</div>
        <img src="@/assets/img/login/yhm.png" alt @click="showLoginForm" />
      </div>
    </div>
    <div class="form-body">
      <div class="qrcode" v-show="showQrCode">
        <div class="qrbody">
          <div class="masking" v-show="showFail">
            <div>
              <p>二维码失效</p>
              <button @click.prevent="refreshCode">刷新</button>
            </div>
          </div>
          <div style="width:200px;height:200px;margin-left:50px;">
            <img :src="qrUrl" style="width:200px;height:200px;" alt class="qrimg" />
          </div>
          <div class="close-sms" :style="{ opacity: showCloseBody }">
            <p style="color:#000;text-align:left">
              维护大师APP扫一扫
            </p>
            <p style="color:#000;text-align:left">
              无需绑定，将维护大师APP更新到最新版本，使用如图所指示的扫一扫功能，扫描二维码，就可安全快捷地完成登录。
            </p>
            <p>
              <img src="@/assets/img/icon/u150.png" alt />
            </p>
            <p>黄圈所示为扫一扫功能</p>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="qrsao">
          <img src="@/assets/img/icon/u156.png" alt />
          <p>
            打开“
            <span style="color:rgb(35, 138, 255)">维护大师APP</span>”，扫一扫登录
          </p>
          <p>
            <a :href="$PAGE_API.other.downloadApp" style="margin-right:10px;color:#000" target="_blank">下载维护大师APP</a>
          </p>
        </div>
        <div>
          <p class="qr-footer" style="width:320px; text-align:left;">
            <span>其他登录方式：</span>
            <img src="@/assets/img/icon/u284.png" alt @click.prevent="showWxLogin"
              style="width:20px;height:16px;margin-left:10px" />

            <span class="fr" @click.prevent="showRegisteredForm">前往注册</span>
            <span class="forget fr" style="margin-right:10px;" @click.prevent="toReset">忘记密码？</span>
          </p>
        </div>
      </div>
      <div class="qrcode" v-show="!showQrCode">
        <img src="@/assets/img/icon/u3975.png" style="width:170px;" alt class="qrimg" />
        <div class="qrsao">
          <img src="@/assets/img/icon/u156.png" alt />
          <p>扫码成功</p>
          <p>请在手机上点击“确认登录”，即可登录</p>
        </div>
        <div>
          <p style="text-align:center">
            <a href="#" @click.prevent="showQrcodeBox(1)">重新扫码</a>
          </p>
        </div>
      </div>
    </div>
    <div style="padding-top: 30px;margin-left: -40px;">v3版维护大师入口：<a href="https://zhiweicloud.com" class="mainCol f14 fw">https://zhiweicloud.com</a></div>
  </div>
</template>
<script>
import http from '@/utils/http';
import { mapActions } from 'vuex';
import { Message } from 'view-design';
window.$msg = Message;
export default {
  props: {
    showQr: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      qrUrl: '',
      showQrCode: true,
      nums: '',
      numInerval: '',
      interval: '',
      showCloseBody: 1,
      showFail: false,
      failTimeout: '',
      lastTime: '',
      nowTime: '',
      reloadPoll: 0
    };
  },
  methods: {
    toReset () {
      this.$router.push({
        path: this.$PAGE_API.reset.path,
      });
    },
    ...mapActions(['user/actionSetStatement']),
    // 获取二维码
    /* eslint-disable */
    getQrcode (type) {
      let chars = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
      ];
      // var nums="";
      this.nums = "";
      for (let i = 0; i < 32; i++) {
        let id = parseInt(Math.random() * 61);
        this.nums += chars[id];
      }
      this.lastTime = Math.round(new Date().getTime() / 1000);
      this.nums += this.lastTime;
      this.qrUrl =
        "/api/common/getQrCode.htm" + "?" + "code=" + this.nums;
    },
    // 轮询扫码
    async pollQrcode (flag) {
      let res = await http.post({
        url: "/api/common/getQrStatus.htm",
        data: {
          code: this.nums,
          type: "json"
        }
      });
      if (res.msg == "scanSuccess") {
        this.showQrCode = false;
        this.showFail = true;
        clearTimeout(this.numInerval);
      }
      if (res.msg == "authorize") {
        this.qrLogin();
        this.clear();
      }
      if (res.msg == "expired") {
        this.clear();
        this.qrFail();
      }
      clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        this.pollQrcode();
      }, 3000);
    },
    clear () {
      clearTimeout(this.interval);
      clearTimeout(this.numInerval);
    },
    async qrLogin () {
      let res = await http.post({
        url: "/api/qrLogin",
        data: {
          code: this.nums
        }
      });
      if (res.code == 200) {
        this["user/actionSetStatement"](1);
        this.clear();
        if (
          window.location.href.split("val=").length > 1 &&
          window.location.href.split("val=")[1] == "1"
        ) {
          this.$router.push({
            path: this.$PAGE_API.home.children.VIPInfo.path
          });
        } else if (
          window.location.href.split("val=").length > 1 &&
          window.location.href.split("val=")[1] == "2"
        ) {
          this.$router.push({
            path: this.$PAGE_API.home.path + "?val=2"
          });
        } else {
          this.$router.push({
            path: this.$PAGE_API.home.path
          });
        }
      } else {
        // window.$msg({
        //   showClose: true,
        //   type: "error",
        //   message: res.msg
        // });
        this.$message.error(res.msg);
        this.showQrCode = true;
        this.clear();
        this.getQrcode();
        this.pollQrcode();
      }
    },
    showRegisteredForm () {
      this.$emit("showRegisteredForm");
    },
    showLoginForm () {
      this.$emit("showLoginForm");
    },
    showWxLogin () {
      this.$emit("showWxLogin");
    },
    showQrcodeBox (type) {
      this.showQrCode = true;
      clearTimeout(this.numInerval);
      this.getQrcode(type);
    },
    qrFail () {
      this.showFail = true;
      this.clear();
      this.reloadPoll = 1;
    },
    reloadPollCode () {
      if (this.reloadPoll == 1) {
        this.pollQrcode();
        this.reloadPoll = 0;
      }
    },
    refreshCode () {
      this.reloadPoll = 0;
      this.showFail = false;
      this.clear();
      this.getQrcode();
      setTimeout(() => {
        this.pollQrcode();
      }, 3000);
    }
  },
  mounted () {
    window.timeOutLoginQr = () => {
      this.clear();
    };
    this.getQrcode();
    setTimeout(() => {
      this.pollQrcode();
    }, 3000);
    setTimeout(() => {
      this.showCloseBody = 0;
    }, 10000);
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
      vm.clear(); // 清除定时器
    });
  }
};
</script>
<style lang="scss" scoped>
.login-form,
.register-form {
  padding: 20px 30px;
  width: 380px;
  height: 440px;
  border-radius: 3px;
  background-color: #fff;
  // backface-visibility: hidden;
}

// 表单头部
.form-header {
  display: flex;
  justify-content: space-between;

  p {
    font-size: 20px;
    font-weight: bold;
  }

  .form-weixin {
    display: flex;

    .go-weixin {
      padding-left: 8px;
      transform: translateX(5px);
      width: 96px;
      height: 28px;
      background: url(../../assets/img/login/wx.png) no-repeat;
      color: #00c2de;
      line-height: 28px;
      font-weight: bold;
      text-align: left;
      margin-right: 8px;
    }

    img {
      cursor: pointer;
    }

    img:hover {
      opacity: 0.8;
      transition: opacity 0.2s;
    }
  }
}

// 表单主体
.form-body {
  .form-group {
    width: 100%;
    padding: 10px 0;

    div {
      overflow: hidden;
      width: 100%;
      line-height: 29px;
      background-color: #fdfae6;
      border: 1px solid #ff934c;
      color: #8c8b85;
      text-align: left;

      img {
        float: left;
        margin: 5px 10px;
      }
    }

    .forget {
      position: absolute;
      top: 25px;
      right: 20px;
      // transform: translate(90px, -30px);
      color: rgb(0, 153, 204);
      cursor: pointer;
    }
  }

  // 表单底部
  p {
    color: #abadae;
    text-align: right;

    a:hover {
      color: #00c2de;
    }
  }

  .span {
    position: absolute;
    top: 460px;
    margin-bottom: 30px;
    line-height: 20px;
    font-size: 14px;
    color: #00c2de;
    text-align: left;
    cursor: pointer;
  }

  .p-footer {
    line-height: 70px;
    color: #abadae;
    text-align: left;

    img {
      position: absolute;
      width: 20px;
      transform: translate(10px, 25px);
      cursor: pointer;
    }

    img:last-child {
      transform: translate(45px, 27px);
    }

    span {
      float: right;
      color: rgb(0, 153, 204);
      font-size: 14px;
      font-weight: inherit;
      cursor: pointer;
    }
  }

  // 扫码登录
  .qrcode {
    margin: 30px auto;
    width: 300px;

    // background-color: #0f0;
    img {
      width: 200px;
    }

    .qrimg {
      width: 200px;
      height: 200px;
    }

    .masking {
      position: absolute;
      transform: translateX(50px);
      width: 200px;
      height: 200px;
      background-color: rgba(255, 255, 255, 0.9);

      div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 60px;
        font-size: 14px;

        p {
          color: #000;
        }

        button {
          margin-top: 10px;
          width: 80px;
          height: 30px;
          background-color: rgb(0, 153, 204);
          color: #fff;
        }

        button:hover {
          background-color: rgb(0, 188, 255);
        }
      }
    }

    .qrsao {
      padding-left: 15px;
      margin-top: 20px;

      img {
        margin-top: 5px;
        float: left;
        width: 30px;
      }

      p {
        padding-left: 50px;
        padding-bottom: 5px;
        color: #000;
        font-weight: inherit;
        font-size: 14px;
        text-align: left;
      }

      p:nth-child(3) {
        font-size: 12px;
      }

      // p:nth-child(3):hover{
      //     color: rgb(0, 153, 204);
      // }
    }

    div:nth-child(3) {
      margin-top: 30px;

      p {
        font-weight: inherit;
        font-size: 12px;
        text-align: right;
        cursor: pointer;
        color: rgb(171, 173, 174);

        a {
          color: rgb(171, 173, 174);
        }
      }
    }

    .qr-footer {
      position: absolute;
      top: 461px;
      left: 30px;
    }

    .qrbody {
      position: relative;
    }

    .qrbody:hover .close-sms {
      opacity: 1 !important;
      // visibility: visible;
      transform: translate(290px, -190px);
      transition: all 0.3s;
    }

    .close-sms {
      top: 175px;
      opacity: 0;
      // visibility: hidden;
      position: absolute;
      transform: translate(280px, -190px);
      width: 250px;
      padding: 10px 15px;
      background: rgb(245, 245, 245);
      box-shadow: 1px 2px 5px rgb(216, 216, 216);
      border: 1px solid rgb(215, 215, 215);
      border-radius: 3px;
      transition: all 0.2s;

      p {
        padding-left: 0;
        margin-bottom: 20px;
        font-size: 12px;
        text-align: left;
        color: #000;
        font-weight: inherit;

        span {
          color: rgb(0, 153, 204);
        }

        img {
          width: 100%;
          margin-bottom: 0px;
        }
      }

      p:first-child {
        font-size: 14px;
      }

      p:nth-child(4) {
        padding-top: 0px;
        margin-bottom: 10px;
        color: rgb(180, 169, 180);
        text-align: right;
      }

      span:nth-child(5) {
        display: block;
        position: absolute;
        left: -7px;
        top: 50px;
        width: 12px;
        height: 12px;
        border: 1px solid rgb(215, 215, 215);
        background: rgb(245, 245, 245);
        transform: rotateZ(-45deg);
        box-shadow: 1px 2px 5px rgb(216, 216, 216);
      }

      span:nth-child(6) {
        display: block;
        position: absolute;
        left: 0px;
        top: 47px;
        width: 14px;
        height: 24px;
        background: rgb(245, 245, 245);
      }
    }
  }
}
</style>
